/**
 * Staff 等级 → SVG 图标映射（4 级独立体系，与用户会员等级完全分离）
 * Level 1-4: 成员 / 熟练 / 资深 / 核心 | Fallback: level_01
 *
 * 与 memberLevelIcons.js 互不引用：role=岗位（admin/operator/courier），
 * staff_level=成长等级（1-4），两者严格分离。
 */
const iconMap = {
  1: require('@/assets/icons/staff-level/level_01.svg'),
  2: require('@/assets/icons/staff-level/level_02.svg'),
  3: require('@/assets/icons/staff-level/level_03.svg'),
  4: require('@/assets/icons/staff-level/level_04.svg')
}

const FALLBACK = iconMap[1]

export function getStaffLevelIcon (level) {
  return iconMap[level] || FALLBACK
}

export default iconMap
